import { compose } from "redux";
import { Field } from "redux-form/immutable";
import React, { PureComponent } from "react";

import { required } from "utils/validation.util";
import TextField from "app/components/form/TextField";
import { COURSE_GROUP_FORM } from "features/competence.constants";

class CourseGroupForm extends PureComponent {
  render() {
    const { handleSubmit } = this.props;

    return (
      <form id={COURSE_GROUP_FORM.ID} onSubmit={handleSubmit}>
        <Field
          autoFocus
          required
          label="Name"
          validate={[required]}
          component={TextField}
          name={COURSE_GROUP_FORM.NAME}
        />
      </form>
    );
  }
}

export default compose()(CourseGroupForm);
